// extracted by mini-css-extract-plugin
export default {"container":"depositListItem_container__XoSPA","wrapper":"depositListItem_wrapper__0lOgL","top":"depositListItem_top__7WxFS","bottom":"depositListItem_bottom__sZmS7"};